<template>
  <v-container>
    <div class="login">
      <v-form>
        <v-card pa-1 width="500" height="auto"  class="elevation-7 mx-auto text-center mt-1 pa-2 rounded-lg">
          <v-card-text>
            <v-text-field outlined rounded
              class="mx-auto mt-5 select"
              style="width: 100%; " 
              prepend-inner-icon="mdi-lock" 
              :type="showPrePassword ? 'text' : 'password'" 
              :append-icon="showPrePassword ? 'mdi-eye' : 'mdi-eye-off'"
              label="현재 비밀번호"
              ref="cpassword" 
              v-model="cpassword"
              @click:append="showPrePassword = !showPrePassword"
              clearable
            />
            <v-text-field outlined rounded
              class="mx-auto mt-5 select"
              style="height: 45px; width: 100%; " 
              prepend-inner-icon="mdi-lock" 
              :type="showNewPassword ? 'text' : 'password'" 
              :append-icon="showNewPassword ? 'mdi-eye' : 'mdi-eye-off'"
              label="새 비밀번호"
              ref="npassword" 
              v-model="npassword"
              @click:append="showNewPassword = !showNewPassword"
              clearable
            />
            <v-text-field outlined rounded
              class="mx-auto mt-5 select"
              style="height: 45px; width: 100%; " 
              prepend-inner-icon="mdi-lock" 
              :type="showConfirmPassword ? 'text' : 'password'" 
              :append-icon="showConfirmPassword ? 'mdi-eye' : 'mdi-eye-off'"
              label="비밀번호 확인"
              ref="rpassword" 
              v-model="rpassword"
              @click:append="showConfirmPassword = !showConfirmPassword"
              clearable
            />
          </v-card-text>

        <v-card-actions class="justify-center d-block">
          <v-layout wrap>
            <v-spacer></v-spacer>
            <button v-if="this.$getters.userName !== '방문고객'" 
              id="confirm_btn" 
              class="normal-btn mt-5"  
              type="submit" 
              @click.prevent="changePassword()">
              확인
            </button>
            <button 
              id="cancel_btn" 
              class="new-btn mt-5 ml-3"  
              @click="cancel()">
              취소
            </button>
            <v-spacer></v-spacer>
          </v-layout>


          
        </v-card-actions>
      </v-card>
      </v-form>

    </div>

  </v-container>
</template>

<script>
  export default {
    name: 'ChangePW',

    data() {
      return {
        cpassword: "",
        npassword: "",
        rpassword: "",
        showPrePassword: false,
        showNewPassword: false,
        showConfirmPassword: false,
      };
    },
    mounted() {
      this.$refs.cpassword.focus();
    },

    methods : {
      // ...mapMutations(['doLogin']),
      cancel() {
        this.$router.go(-1);
      },

      changePassword() {
        let cpw = this.cpassword.trim();
        let npw = this.npassword.trim();
        let rpw = this.rpassword.trim();
        if (!cpw) {
          alert("현재 비밀번호를 입력해주세요.");
          this.$refs.cpassword.focus();
          return;
        }
        if (!npw) {
          alert("새 비밀번호를 입력해주세요.");
          this.$refs.npassword.focus();
          return;
        }
        if (!rpw) {
          alert("새 비밀번호를 한번 더 입력해주세요.");
          this.$refs.rpassword.focus();
          return;
        }
        if ( npw !== rpw ) {
          alert("새 비밀번호와 확인이 다릅니다.");
          this.$refs.npassword.focus();
          return;
        }

        this.$dispatch("changePassword", {
          now_pw: cpw,
          new_pw: npw,
        }).then((res) => {
          if (res.result) {
            alert("비밀번호 변경 : " + res.message);
            this.$router.go(-1);
          } else {
            alert("Error Code : " + res.resultCode + "\n" + res.message);
            this.$refs.cpassword.focus();
            return;
          }
        });
      },
    }
  }
</script>


<style lang="scss" scoped>
// @import './info_style.scss';

.select{
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1) !important;
  height:58px !important;
  border-radius: 20px !important;
}
.normal-btn{
  border-radius: 25px;
  color:white !important;
  width:90px !important;
  height:45px !important;
  font-size:12pt !important;
  font-weight: bold !important;
  background-color: #005B96 !important;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
}
.new-btn{
  border-radius: 25px;
  width:90px !important;
  height:45px !important;
  color:#005B96 !important;
  font-size:12pt !important;
  font-weight: bold !important;
  background-color: rgb(248, 248, 248) !important;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
}
</style>